import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import Clarity from '@microsoft/clarity';


@Injectable({
    providedIn: 'root'
})
export class ClarityService {

    loginEventName = 'clarity-login-event';
    private readonly events = {
        [this.loginEventName]: 'clarity_on_login'
    };

    loadUserClarity(dataInfo: any): void {

        Clarity.init(environment.clarityId);

        Clarity.identify(dataInfo.userToken, undefined, undefined, dataInfo.email);

        Clarity.setTag('name', dataInfo.name);
        Clarity.setTag('lastname', dataInfo.lastname);
        Clarity.setTag('email', dataInfo.email || '');
        Clarity.setTag('idCenter', dataInfo.idCenter);
        Clarity.setTag('centername', dataInfo.centername);

        this.sendEvent(this.loginEventName);
    }

    sendEvent(eventName: string): void {

        if (this.isEventSent(eventName)) {
            return;
        }

        Clarity.event(this.events[eventName]);
        this.setEventAsSent(eventName);

        Clarity.consent(true);
    }

    isEventSent(eventName: string): boolean {
        const item = sessionStorage.getItem(eventName);

        return item ? JSON.parse(item) : false;
    }

    private setEventAsSent(eventName: string): void {
        sessionStorage.setItem(eventName, 'true');
    }
}
